module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_67.338f6a48.png";